import { OktaAuth } from '@okta/okta-auth-js';
import env from '../configs/env';

export const oktaAuth = new OktaAuth({
  issuer: env.auth.okta?.issuer || '',
  clientId: env.auth.clientId,
  redirectUri: env.auth.okta?.redirectUri,
  postLogoutRedirectUri: env.auth.okta?.logoutUri,
  scopes: ['treaty.user', 'openid', 'profile', 'email', 'offline_access'],
  pkce: true,
  responseType: 'code',
  dpop: true,
  tokenManager: {
    storage: env.auth.cacheLocation,
    autoRenew: true,
    autoRemove: true,
    expireEarlySeconds: 300,
    clearPendingRemoveTokens: true,
  },
  services: {
    autoRenew: true,
  },
});

export async function fetchWithAuth(url: string, options: RequestInit) {
  let parsed: URL | null = null;
  try {
    parsed = new URL(url);
  } catch (err) {
    console.error(new Error(`Failed to parse url: '${url}'. Will use as is for signing dpop proof`, { cause: err }));
  }
  const urlForDpop = parsed !== null ? `${parsed.origin}${parsed.pathname}` : url;
  const method = options.method ?? "GET";
  const authHeaders = await oktaAuth.getDPoPAuthorizationHeaders({ method, url: urlForDpop });
  const updatedHeaders: HeadersInit = {...options.headers, ...authHeaders};
  const updatedOptions: RequestInit = {...options, headers: updatedHeaders };
  return await fetch(url, updatedOptions);
}

export type FetchWithAuth = typeof fetchWithAuth;

// Start token manager for automatic refresh
oktaAuth.start();